import { render, staticRenderFns } from "./batchModal.vue?vue&type=template&id=151f8cba&scoped=true"
import script from "./batchModal.vue?vue&type=script&lang=js"
export * from "./batchModal.vue?vue&type=script&lang=js"
import style0 from "./batchModal.vue?vue&type=style&index=0&id=151f8cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f8cba",
  null
  
)

export default component.exports